import React, { Component } from 'react';
import globalVariables from '../../custom_libraries/globalVariables';
import {Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
        Paper, IconButton, Typography, Box,Tabs, Tab } from '@mui/material';
import Navigationbar from '../Navigationbar';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import { Link } from "react-router-dom";
import Backdrop from '@mui/material/Backdrop';
import WebLogo from '../../assets/Artboard 1Bonus.png';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import Tooltip from '@mui/material/Tooltip';
import CancelIcon from '@mui/icons-material/Cancel';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import LinkIcon from '../../assets/ip-globe-icon.png';
import NotificationsIcon from '@mui/icons-material/Notifications';
import NotificationsOffIcon from '@mui/icons-material/NotificationsOff';
import { get, post, del, getFreshToken } from '../../custom_libraries/serverRequests';
import urls from '../../custom_libraries/urls';

class recordDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            recordDetails: [],
            activeTab: 0, // Default to the first tab (General Info)
            Selected_Device_Id:null,
            storedLogo: localStorage.getItem("USER_LOGO") || null,
        }
    }

    componentDidMount() {
        const Selected_Camera_Id = localStorage.getItem(globalVariables.CAMERA_ID);
        console.log("Camera ID: ", localStorage.getItem(globalVariables.CAMERA_ID));

        const siteName = localStorage.getItem(globalVariables.SITE_NAME);
        const deviceName= localStorage.getItem(globalVariables.DEVICE_NAME);
        const Selected_Device_Id = localStorage.getItem(globalVariables.DEVICE_ID);
        this.setState({ Selected_Device_Id }, () => {
            this.LoadSelectedDeviceInfo(); // Ensure this runs after state is updated
        });
        const user_type = localStorage.getItem(globalVariables.USER_TYPE);
        this.setState ({
            SiteName : siteName,
            DeviceName : deviceName,
            user_type : user_type
        })
    }

    //------------------ get device info----------------------------------------------------------------------
       LoadSelectedDeviceInfo = async () => {
        //  this.setState({ editToggle: true });
        console.log("--------deviceId---------", this.state.Selected_Device_Id);
         try {
           let access_tocken = localStorage.getItem(globalVariables.AUTH_TOKEN)
           
           let headers = {
               'content-type': 'application/json',
               'Authorization': `Bearer ${access_tocken}`
           }
           const url = urls.DEVICE_DETAILS(this.state.Selected_Device_Id);  // static method defined in urls.jsx: passed the deviceId of selected device (device row)      const response = await get(url);
           const response = await get(url, headers); // Perform the API call using the constructed URL
           console.log(`API Response for LoadSelectedDeviceInfo ${this.state.Selected_Device_Id}:`, response);
     
           if (response && Object.keys(response).length > 0) {
             console.log(`API Response for LoadSelectedDeviceInfo ${this.state.Selected_Device_Id}:`, response);
             this.setState({ 
              devices:response.data[0]
              });
     
           } else {
             console.error("No valid data returned from the get-camera API");
           }
        
         } catch (error) {
           console.error("Error fetching cameras from API:", error);
         }
       };

  getCurrentTimeInDeviceTimezone = (timezone ) => {
    try {
      // Get the current time in the specified timezone
      const localTime = new Intl.DateTimeFormat("en-US", {
          timeZone: timezone,
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
          hour: "2-digit",
          minute: "2-digit",
          hour12: true, // Use 12-hour format
      }).format(new Date());
        

      return localTime;
    } catch (error) {
        console.error("Error calculating device time:", error);
        return "Error calculating time";
    }
};

  formatToUSDateTime = (datetimeStr) => {
    if (!datetimeStr || typeof datetimeStr !== "string" || !datetimeStr.includes(",")) {
      console.warn("Invalid datetime string:", datetimeStr);
      return "Invalid Date";
    }
    // console.log("device time received,", datetimeStr);
    // input: "11/04/2025,07:22" (DD/MM/YYYY, 24hr format)
    const [datePart, timePart] = datetimeStr.split(",");
    const [day, month, year] = datePart.split("/");

    const [hour, minute] = timePart.split(":");
    const date = new Date(`${year}-${month}-${day}T${hour}:${minute}`);

    return new Intl.DateTimeFormat("en-US", {
      month: "2-digit",
      day: "2-digit",
      year: "numeric",
      hour: "numeric",
      minute: "2-digit",
      hour12: true,
    }).format(date); // returns: "04/11/2025, 7:22 AM"
  }

    render() {
          const { activeTab, cameras, loading, SiteName,  DeviceName, devices } = this.state;

        return (
            <div style={{height:'100vh', overflow:'hidden'}}>
                        {/* Navigation Bar */}
                        <Navigationbar />
                  
                        <div style={{ backgroundColor: '#fafafa', display: 'flex', flexDirection: 'column', marginLeft:'3%' }}>
                    
                        {/* Main Content with Flexbox Layout */}
                        <Box
                        sx={{
                            display: 'flex',
                            marginLeft: '6.2%',
                            marginRight:'2%',
                            marginTop:'0.5%',
                            backgroundColor: '#fafafa',
                            height:'35px',
                        }}>
                            <TableContainer component={Paper} sx={{display: 'flex', height:'100%', alignItems:"center", paddingLeft:'10px'}}>
                            <Typography variant="subtitle1" fontWeight="bold" display="flex" alignItems="center">
                               <Link to="/showDevices"> Sites</Link>  <KeyboardArrowRightIcon fontSize="large" color="primary" /> {SiteName} <KeyboardArrowRightIcon fontSize="large" color="primary" /> {DeviceName}
                            </Typography>
                            </TableContainer>
                        </Box>
                        {/* Main  Content Layout */}
                            <Box 
                            sx={{
                                display: 'flex',
                                marginLeft: '5%',
                                backgroundColor: '#fafafa',
                            }}
                            >
                  
                            {/* Main device Content Area */}
                            <Box
                            sx={{
                                flexGrow: 1, // Occupy remaining horizontal space
                                padding: '16px',
                                minWidth: 0, // Prevent content overflow
                                height: '88vh',
                                overflowY: 'scroll',
                                "&::WebkitScrollbar": {
                                  width: "8px", // Adjust scrollbar thickness
                                },
                                "&::WebkitScrollbarThumb": {
                                  backgroundColor: "#aaa", // Color of the scrollbar thumb
                                  borderRadius: "4px", // Rounded corners for the thumb
                                },
                                "&::WebkitScrollbarThumb:hover": {
                                  backgroundColor: "#888", // Color when hovered
                                },
                                scrollbarWidth: "1px", // Adjust scrollbar thickness in Firefox
                                scrollbarColor: "#aaa #f0f0f0",
                              }}
                            >
                              {/* Subtab Bar */}
                              <Tabs
                                value={activeTab}
                                onChange={this.handleTabChange}
                                indicatorColor="primary"
                                textColor="primary"
                                variant="fullWidth"
                                component={Paper}
                              >
                                <Tab label="General Info" sx={{
                                  backgroundColor: activeTab === 0 ? "#d1e8ff" : "transparent",
                                  color: activeTab === 0 ? "#000" : "inherit",
                                  fontWeight: activeTab === 0 ? 550 : 500
                                }} />
                                
                                </Tabs>
                              <>
                                {/* Tab Content */}
                                <Box sx={{ marginTop: 0.5 }}>
                                  {activeTab === 0 && (
                                  <>
                                    <div style={{display:'flex', justifyContent:'right'}}>
                                      {/* <img
                                        src={SyncIcon1} 
                                        alt="sync-icon" 
                                        width="50px" 
                                        onClick={this.syncSelectedDevice} 
                                        title="Sync Device" 
                                        style={{cursor:'pointer'}} 
                                      /> */}
                                    </div>
                                    <TableContainer component={Paper} >
                                    <Table style={{ tableLayout: 'auto', width: '100%'}}>
                                        <TableHead>
                                        <TableRow>
                                            {[
                                            'Group Name',
                                            'Site Name',
                                            'HDD Storage (Used/Total)',
                                            'System Channel Max',
                                            'Active Cameras',
                                            'Current Site Time',
                                            'Current Device Time',
                                            'Online',
                                            'Storage Health',
                                            'Users',
                                            'IP Address',
                                            ].map((header) => (
                                            <TableCell key={header} align="center">
                                                <Typography variant="subtitle2" fontWeight="bold">
                                                {header}
                                                </Typography>
                                            </TableCell>
                                            ))}
                                        </TableRow>
                                        </TableHead>
                                        <TableBody>
                                        {devices && (
                                            <React.Fragment key={devices.id}>
                                            <TableRow>
                                                <TableCell align="center">
                                                  {devices.device_name}
                                                </TableCell>
                                                <TableCell align="center">{devices.site_name || 'N/A'}</TableCell>
                                                <TableCell align="center" >
                                                  {devices && Array.isArray(devices.hard_disks) && devices.hard_disks.length > 1 ? 
                                                  (
                                                    <div>
                                                      {(() => {
                                                        const totalFreeSpace = devices.hard_disks.reduce(
                                                          (acc, disk) => acc + (parseFloat(disk.free_space_gb) || 0),
                                                          0
                                                        );
                
                                                        const totalSpace = devices.hard_disks.reduce(
                                                          (acc, disk) => acc + (parseFloat(disk.total_space_gb) || 0),
                                                          0
                                                        );
                
                                                        return (
                                                          <>
                                                            <div style={{ display: "flex", alignItems: "center", gap: "1px" }}>
                                                              {/* <span style={{ color: this.getHDDColor(totalFreeSpace, totalSpace) }}>
                                                                {totalFreeSpace.toFixed(2)}/{totalSpace.toFixed(2)}
                                                              </span> */}
                                                              {/* <IconButton onClick={() => this.toggleDetails(devices.id)} size="small">
                                                                <InfoOutlinedIcon fontSize="small" sx={{ ml: 0.5 }} />
                                                              </IconButton> */}
                                                            </div>
                                                            {/* {this.state.showDiskDetails[devices.id] && (
                                                              <div>
                                                                {devices.hard_disks.map((disk) => (
                                                                  <p key={disk.disk_id} style={{ color: this.getHDDColor(disk.free_space_gb, disk.total_space_gb) }}>
                                                                    hdd{disk.disk_id}:{disk.free_space_gb}/{disk.total_space_gb}
                                                                  </p>
                                                                ))}
                                                              </div>
                                                            )} */}
                                                          </>
                                                        );
                                                      })()}
                                                    </div>
                                                  ) : (
                                                    <div>
                                                      {/* { devices && Array.isArray(devices.hard_disks) && devices.hard_disks.map((disk) => (
                                                        <p key={disk.disk_id} style={{ color: this.getHDDColor(disk.free_space_gb, disk.total_space_gb) }}>
                                                          {disk.free_space_gb}/{disk.total_space_gb}
                                                        </p>
                                                      ))} */}
                                                    </div>
                                                  )}
                                                </TableCell>
                                                <TableCell align="center">{devices.chl_max_count}</TableCell>
                                                <TableCell align="center" style={{paddingRight:'2px'}}>{devices.total_cameras}</TableCell>
                                                <TableCell align="center">
                                                <div style={{ display: "flex", alignItems: "center", gap: "1px" }}>
                                                  
                                                  {(devices.status === "active" && devices.current_time !== null) ? (
                                                    <Box color={devices.timezone_match ? 'green' : 'red'}>
                                                    {this.getCurrentTimeInDeviceTimezone(devices.site_timezone)}
                                                    </Box>
                                                  ) : (
                                                    <Box color={'black'}>
                                                    {this.getCurrentTimeInDeviceTimezone(devices.site_timezone)}
                                                    </Box>
                                                  )}
                                                  {devices.site_timezone && (
                                                    <Tooltip
                                                      title={
                                                        `Timezone: ${devices.site_timezone}`
                                                      }
                                                    >
                                                      <InfoOutlinedIcon
                                                        fontSize="small"
                                                        sx={{ ml: 0.5 }}
                                                      />
                                                    </Tooltip>
                                                  )}
                                                  </div>
                                                </TableCell>
                                                <TableCell align="center">
                                                  <div style={{ display: "flex", alignItems: "center", gap: "2px" }}>
                                                    {devices.status === "active" ? (
                                                      <Box color={devices.timezone_match ? 'green' : 'red'}>
                                                      {this.formatToUSDateTime(devices.current_time)} 
                                                      </Box>
                                                    ) : (
                                                      <Box color={'orange'}>
                                                      {"--"} 
                                                      </Box>
                                                    )}
                                                    {devices.current_time && (
                                                    <Tooltip
                                                      title={
                                                        `Timezone: ${devices.timezone}`
                                                      }
                                                    >
                                                      <InfoOutlinedIcon
                                                        fontSize="small"
                                                        sx={{ ml: 0.5 }}
                                                      />
                                                    </Tooltip>
                                                    )}
                                                  </div>
                                                </TableCell>
                                                
                                                <TableCell align="center">
                                                <Tooltip title={devices.status === 'active' ? 'Device is active' : 'Device is inactive'}>
                                                    {devices.status === 'active' ? (
                                                    <CheckCircleIcon color="success" />
                                                    ) : (
                                                    <CancelIcon color="error" />
                                                    )}
                                                </Tooltip>
                                                </TableCell>
                                                
                                                <TableCell align="center" >
                                                  {/* {devices && Array.isArray(devices.hard_disks) && devices.hard_disks.length > 0 ? (() => {
                                                    const allHikevisionHealthy = devices.hard_disks.every(disk => disk.status === "idle" || disk.status === "ok");
                                                    const allNvrHealthy = devices.hard_disks.every(disk => disk.status === "RW" || disk.status === "read/write");
                                                    const isHikevision = devices.device_type_name === "hikvision";
                                                    const isTvtNvr = devices.device_type_name === "nvr";
            
                                                    const multipleDisks = devices.hard_disks.length > 1;
                                                    const singleDisk = devices.hard_disks.length === 1;
                
                                                    return (
                                                          <div style={{ alignItems: "center"}}>
                                                            <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                                                              {isHikevision && devices.status === "active" ?
                                                              (
                                                                <Tooltip title={allHikevisionHealthy ? "All disks are healthy" : "One or more disks have issues"}>
                                                                {allHikevisionHealthy ? (
                                                                  <CheckCircleIcon color="success" />
                                                                ) : (
                                                                  <CancelIcon color="error" />
                                                                )}
                                                              </Tooltip>
                                                              ):(isTvtNvr && devices.status === "active" ? 
                                                                (
                                                                <Tooltip title={allNvrHealthy ? "All disks are healthy" : "One or more disks have issues"}>
                                                                  {allNvrHealthy ? (
                                                                  <CheckCircleIcon color="success" />
                                                                ) : (
                                                                  <CancelIcon color="error" />
                                                                )}
                                                                </Tooltip>
                                                              ):(devices.status === "inactive" && <CancelIcon color="error" />)
                                                              )
                                                              }
                                                              
                                                              {multipleDisks ? (
                                                              <IconButton onClick={() => this.toggleDetails(devices.id)} size="small">
                                                                <InfoOutlinedIcon fontSize="small" />
                                                              </IconButton>
                                                            ) : singleDisk ? (
                                                              <Tooltip title={devices.hard_disks[0].status}>
                                                                <InfoOutlinedIcon fontSize="small" />
                                                              </Tooltip>
                                                            ) : null}
                                                            </div>
                  
                                                            {multipleDisks && this.state.showDiskDetails[devices.id] && (
                                                              <div style={{ marginTop: "5px" }}>
                                                                {devices.hard_disks.map((disk) => (
                                                                  <div key={disk.disk_id} style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                                                                    <span>hdd{disk.disk_id}:</span>
                                                                    {isHikevision ? (
                                                                        disk.status === "ok" || disk.status === "idle" ? (
                                                                          <Tooltip title={disk.status}
                                                                            slotProps={{
                                                                                popper: {
                                                                                  modifiers: [
                                                                                    {
                                                                                      name: "offset",
                                                                                      options: {
                                                                                        offset: [28, -25], // Adjusts distance from cursor (Y = -5 moves closer)
                                                                                      },
                                                                                    },
                                                                                  ],
                                                                                },
                                                                              }}
                                                                          >
                                                                            <CheckCircleIcon color="success" />
                                                                          </Tooltip>
                                                                        ) : (
                                                                          <Tooltip title={disk.status}>
                                                                            <CancelIcon color="error" />
                                                                          </Tooltip>
                                                                        )
                                                                      ) : isTvtNvr ? (
                                                                        disk.status === "RW" || disk.status === "read/write" ? (
                                                                          <Tooltip title={disk.status}>
                                                                            <CheckCircleIcon color="success" />
                                                                          </Tooltip>
                                                                        ) : (
                                                                          <Tooltip title={disk.status}>
                                                                            <CancelIcon color="error" />
                                                                          </Tooltip>
                                                                        )
                                                                      ) : (
                                                                        <CancelIcon color="error" />
                                                                      )}
                                                                  </div>
                                                                ))}
                                                              </div>
                                                            )}
                                                          </div>
                                                        );
                                                  })() : (
                                                    <Tooltip title={devices.status === "inactive" && Array.isArray(devices.hard_disks) && devices.hard_disks.length === 0  ? "No storage info is available" : "Storage has issues"}>
                                                      <CancelIcon color="error" />
                                                    </Tooltip>
                                                  )} */}
                                              </TableCell>
                                                  
                                                <TableCell align="center">
                                                  {devices?.user_list?.length > 0 ? (
                                                    <>
                                                      {/* {devices.user_list.length}
                                                      <IconButton onClick={() => this.toggleDeviceUserList(devices)} size="small">
                                                        <InfoOutlinedIcon fontSize="small" />
                                                      </IconButton> */}
                                                    </>
                                                  ) : (
                                                    'No Users'
                                                  )}
                                                </TableCell>
                                                <TableCell align="center" style={{ cursor: 'pointer' }}>
                                                {/* <IconButton
                                                    component="a"
                                                    href={`${devices.protocol}://${devices.ip_address}:${devices.port_number}`}
                                                    target="_blank"
                                                >
                                                    <LinkIcon />
                                                </IconButton> */}
                                                <a
                                              component="a"
                                              href={`${devices.protocol}://${devices.ip_address}:${devices.port_number}`}
                                              target="_blank"
                                              rel="noopener noreferrer"
                                              >
                                                <img
                                                src={LinkIcon}
                                                alt="ip-globe"
                                                width="26px"
                                                title="Click here to go to the address"
                                                style={{cursor:'pointer'}}
                                              />
                                              </a>
                                                </TableCell>
                                                
                                            </TableRow>
                                            </React.Fragment>
                                        )}
                                        </TableBody>
                                    </Table>
                                    </TableContainer>
                                  </>
                                  )}
                                  
                                </Box>
                              </>
                              <>
                                <div style={{display: 'flex',justifyContent: 'space-between',alignItems: 'center'}}>
                                  <Typography variant="h6" gutterBottom style={{color:'#1058a0', paddingLeft:'8px'}}>
                                    Cameras
                                  </Typography>                       
                                  {/* <img src={SyncIcon} alt="sync-icon" width="50px" onClick={this.cameraSync} title="Refresh Cameras" style={{cursor:'pointer'}} /> */}
                                </div>
                                  <TableContainer component={Paper} 
                                     
                                      >
                                  <Table style={{ tableLayout: 'fixed', width: '100%'}}>
                                  <TableHead>
                                      <TableRow>
                                      {[
                                          'Camera Name',
                                          'Is live / Image quality',
                                          'Has recordings',
                                          'FPS',
                                          'Resolution',
                                          'Recording type',
                                          'Firmware V.',
                                          'Date',
                                      ].map((header) => (
                                          <TableCell key={header}>
                                          <Typography variant="subtitle2" fontWeight={550}>
                                              {header}
                                          </Typography>
                                          </TableCell>
                                      ))}
                                      </TableRow>
                                  </TableHead>
                                  <TableBody>
                                  {loading ? (
                                    <TableRow>
                                      <TableCell colSpan={6} align="center">
                                        Loading ...
                                      </TableCell>
                                    </TableRow>
                                  ) :
                                  cameras && cameras.length > 0 ? (
                                    cameras.map((camera) => (
                                      <React.Fragment key={camera.id}>
                                        <TableRow >
                                          <TableCell>{camera.camera_name}</TableCell>
                                          <TableCell>
                                              <Tooltip title={(camera.status === 'online' || camera.status === 'Recording') ? 'Camera is active' : 'Camera is inactive'}>
                                              {(camera.status === 'online' || camera.status === 'Recording') ? (
                                                  <CheckCircleIcon color="success" />
                                              ) : (
                                                  <CancelIcon color="error" />
                                              )}
                                              </Tooltip>
                                          </TableCell>
                                          <TableCell>
                                          {/* <td> */}
                                                  {camera.recording_days < this.state.device_details.recording_policy_days ? (
                                                      // <span style={{ color: 'red' }}>
                                                      <span style={{ color: 'red' }}>
                                                        {/* <img src={RecordingRed} alt="less-recording" width="35px" height="30"/><br /> */}
                                                          {camera.recording_days} / 
                                                           {this.state.device_details.recording_policy_days ? `${this.state.device_details.recording_policy_days} days` : 'No policy defined'}
                                                      </span>
                                                  ) :(
                                                    <span style={{ color: '#2e8b57'}}>
                                                        {/* <img src={RecordingGreen} alt="less-recording" width="35px" height="30" /><br /> */}
                                                           <b>{camera.recording_days} / </b>
                                                           <b>{this.state.device_details.recording_policy_days ? `${this.state.device_details.recording_policy_days} days` : 'No policy defined'}</b>
                                                      </span>
                                                  )
                                                  }
                                          </TableCell>
                                          <TableCell>{camera.operator_rating.charAt(0).toUpperCase() + camera.operator_rating.slice(1) }</TableCell>
                                          <TableCell onClick={() => this.toggleMuteUnmuteDIalogue(camera.id)} >{camera.mute === "True" ? (
                                            <span>
                                              {/* <img src={MuteNotificationIcon} alt="muted Notification" title="Muted" width="25px"/>  */}
                                              < NotificationsOffIcon color="error" titleAccess="Muted" cursor="pointer"/>
                                            </span>) : 
                                            <span>
                                              {/* <img src={UnMuteNotificationIcon} alt="muted Notification" title="Unmuted" width="25px"/>  */}
                                              <NotificationsIcon color="success" titleAccess="Unmuted" cursor="pointer"/>
                                            </span>}
                                             
                                              
                                              
                                          </TableCell>
                                          </TableRow>
                                             
                                      </React.Fragment>
                                      ))
                                  ):
                                  (
                                    <TableRow>
                                      <TableCell colSpan={6} align="center" style={{color:'orange'}}>
                                        No camera Details!
                                      </TableCell>
                                    </TableRow>
                                  )}
                                      
                                  </TableBody>
                                  </Table>
                                  </TableContainer>
                              </>
                            </Box>
                            
                        </Box>
            
                        {/* <Box sx={{ display: 'flex', flexGrow: 1 }}> */}
                        {/* Main camera Content Layout */}
                        
                    {/* </Box> */}
                      
                        
                          
                          
                          
                        </div>
            
                        
            
                        {/* Backdrop with Circular Progress */}
                        <Backdrop open={this.state.open_progress_bar}>
                          <div className="custom-spinner">
                              <div className="circle"></div>
                              <div className="circle tilted"></div>
                              <img src={this.state.storedLogo ? this.state.storedLogo : WebLogo} alt="web-logo" style={{backgroundColor:'#001f54', borderRadius:'100px'}}/>
                          </div>
                          {/* <CircularProgress size={80} color="inherit" /> */}
                        </Backdrop>
                    </div>
        );
    }
}
export default recordDetails;